import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import { settings } from 'contexts/settings-context'

const IMG = styled.img`
  height: 32px;
  width: 32px;
  border-radius: 50%;
  margin: 0 12px 0 0;
`

function Avatar(props) {
  const { picture, className } = props
  return <IMG className={className} src={picture || settings.DEFAULT_AVATAR_IMAGE} alt="User Profile" />
}

Avatar.propTypes = {
  picture: PropTypes.string,
  className: PropTypes.string,
}

export default Avatar



// WEBPACK FOOTER //
// ./src/atoms/Avatar/Avatar.js